module.exports = "/dist/assets/logo-black.jpg";